/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

type ExportProgressModalArgs = {
  lastTaskSuccess?: boolean | null;
  lastError?: string | null;
  exportAction: () => unknown;
  onClose: () => unknown;
};

export default class ExportProgressModal extends Component<ExportProgressModalArgs> {
  exportPendingImage = new URL('cio/assets/images/export-pending.svg', import.meta.url).toString();
}
